module.exports = __webpack_public_path__ + "img/new_form_scratch_icon.4dad62eb.svg";